import { useQueryClient } from '@tanstack/react-query'
// import { useState } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useGetDates } from '../../../hooks/date/use-get-dates'
import { ROCKET_GAME_LIVE_FIRST_QUERY_KEY } from '../../../hooks/queries/rockets-games-lives/use-get-rocket-game-live-first'
import {
  ROCKETS_GAMES_LIVES_QUERY_KEY,
  useGetRocketsGamesLives,
} from '../../../hooks/queries/rockets-games-lives/use-get-rockets-games-lives'
import { useSub } from '../../../hooks/subscription/use-sub'
import { useGlobalStore } from '../../../store/global-store'
import type { TypeRocketGameProgress } from '../../../types/lives/notifies'

const LIVE_ROCKET_GAME = '/LIVE-ROCKET-GAME'

interface RocketGame {
  typeRocketGameProgress: TypeRocketGameProgress
  rocketGameLiveId: number
  rocketGameId: number
  imgRocketGame: string
  liveId: number
  message: string
}

export const useLiveRocketGame = () => {
  const queryClient = useQueryClient()

  const { liveId, liveUserId } = useGlobalStore(
    useShallow((state) => ({
      liveId: state?.liveId,
      liveUserId: state?.liveUserId,
    })),
  )

  const { day } = useGetDates()

  console.log('liveUserId', liveUserId)

  const { rocketsGamesLives } = useGetRocketsGamesLives({
    typeFilterDateContribute: 'equal',
    dateContributeInitial: day,
    dateContributeFinal: day,
    userLiveId: liveUserId!,
  })

  const rocketsGameLivesWithoutExploded = rocketsGamesLives?.filter(
    (rocket) => {
      return rocket?.typeRocketGameProgress !== 'exploded'
    },
  )

  const currentRocketGameLive = rocketsGameLivesWithoutExploded?.[0]

  useSub<RocketGame>({
    endpoint: `${LIVE_ROCKET_GAME}/${liveId}`,
    skip: !liveId,
    onData: () => {
      queryClient.invalidateQueries({
        queryKey: [ROCKETS_GAMES_LIVES_QUERY_KEY],
        exact: false,
      })

      queryClient.invalidateQueries({
        queryKey: [ROCKET_GAME_LIVE_FIRST_QUERY_KEY],
        exact: false,
      })
    },
  })

  return {
    // showTimer,
    currentRocketGameLive,
    // setShowTimer,
  }
}
